<template>
  <svg
    fill="currentColor"
    height="800px"
    width="800px"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 392.663 392.663"
    xml:space="preserve"
  >
    <g>
      <g>
        <path
          d="M66.327,286.545H10.925C4.913,286.545,0,291.394,0,297.471v84.234c0,6.012,4.848,10.925,10.925,10.925h55.402
			c6.012,0,10.925-4.848,10.925-10.925v-84.234C77.253,291.394,72.404,286.545,66.327,286.545z M21.851,370.78v-62.448h33.552
			v62.448H21.851z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M171.507,204.186h-55.402c-6.012,0-10.925,4.848-10.925,10.925v166.594c0,6.012,4.848,10.925,10.925,10.925h55.402
			c6.012,0,10.925-4.849,10.925-10.925V215.046C182.432,209.034,177.584,204.186,171.507,204.186z M127.095,370.78V225.972h33.552
			l0,144.808H127.095z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M276.622,121.826H221.22c-6.012,0-10.925,4.848-10.925,10.925v248.954c0,6.012,4.849,10.925,10.925,10.925h55.402
			c6.012,0,10.925-4.848,10.925-10.925V132.687C287.483,126.675,282.634,121.826,276.622,121.826z M265.697,370.78h-33.551V143.612
			h33.551V370.78z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M381.737,39.337h-55.402c-6.012,0-10.925,4.848-10.925,10.925v331.313c0,6.012,4.848,10.925,10.925,10.925h55.402
			c6.012,0,10.925-4.849,10.925-10.925V50.327C392.598,44.315,387.749,39.337,381.737,39.337z M370.812,370.78h-33.552V61.253
			h33.552V370.78z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M223.224,0.032h-57.018c-6.012,0-10.925,4.849-10.925,10.925c0,6.077,4.849,10.925,10.925,10.925h30.707L4.461,214.206
			c-4.267,4.267-4.267,11.119,0,15.451c3.879,3.814,12.541,2.909,15.451,0L212.299,37.269v30.707
			c0,6.012,4.848,10.925,10.925,10.925c6.012,0,10.925-4.848,10.925-10.925V10.958C234.149,4.945,229.301,0.032,223.224,0.032z"
        />
      </g>
    </g>
  </svg>
</template>
